export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';

export const showToast = (status, message) => ({
  type: SHOW_TOAST,
  data: { status, message }
});

export const hideToast = () => ({ type: HIDE_TOAST });
